import { Alert, Button, Checkbox, Form, Input } from 'antd';
import { SVGLogoDark } from '../../images';
import { Container, Content, ExtraActions, FormCard, Welcome } from './styles';
import { useEffect, useState } from 'react';
import { login } from '../../utils/httpRequest';
import { useNavigate } from 'react-router';
import { useAppDispatch } from '../../store';
import { setUser } from '../../slices/profile';

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [rememberPassword, setRememberPassword] = useState(false);

  const submit = async () => {
    try {
      setLoading(true);
      setError('');
      const payload = form.getFieldsValue();
      const res = await login(payload);
      dispatch(setUser(res));
      if (res.firstTimeLogin) {
        navigate('/reset-password');
        return;
      }
      if (rememberPassword) {
        localStorage.setItem('user', JSON.stringify(payload));
      } else {
        localStorage.removeItem('user');
      }
      navigate('/');
    } catch (err: any) {
      console.log(err);
      const errorMsg =
        err?.message ||
        (typeof err === 'string' && err) ||
        'Login failed, Please try again.';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async () => {
    try {
      await form.validateFields();
      submit();
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const userInput = localStorage.getItem('user');
    if (userInput) {
      setRememberPassword(true);
      form.setFieldsValue(JSON.parse(userInput));
    }
  }, []);

  return (
    <Container>
      <Content>
        <SVGLogoDark width={240} />
        <Welcome>Welcome to SolvV</Welcome>
        <FormCard>
          {!loading && error && <Alert message={error} type="error" showIcon />}
          <Form
            form={form}
            layout="vertical"
            size="large"
            disabled={loading}
            onFinish={handleLogin}
          >
            <Form.Item
              label="Email"
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Please input Email address!',
                },
              ]}
            >
              <Input type="text" placeholder="Enter Email address" />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              rules={[
                {
                  required: true,
                  message: 'Please input password!',
                },
              ]}
              extra={
                <ExtraActions>
                  <Checkbox
                    onChange={(e) => setRememberPassword(e.target.checked)}
                    checked={rememberPassword}
                  >
                    Remember me
                  </Checkbox>
                </ExtraActions>
              }
            >
              <Input.Password
                placeholder="Enter password"
                visibilityToggle={{
                  visible: passwordVisible,
                  onVisibleChange: setPasswordVisible,
                }}
              />
            </Form.Item>
            <Button
              type="primary"
              size="large"
              block
              loading={loading}
              htmlType="submit"
            >
              Sign In
            </Button>
          </Form>
        </FormCard>
      </Content>
    </Container>
  );
};

export default Login;
